'use client';

import { RunnerBlockRenderer } from '@unifyapps/carbon/no-code/components/BlockRenderer';
import BlocksRegistry from '@unifyapps/carbon/no-code/context/RegistryProvider/BlocksRegistry';
import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import { ButtonBlockStateDefinition } from '../../Button';
import { CardBlockStateDefinition } from '../../Card';
import { CarouselBlockStateDefinition } from '../../Carousel';
import { DividerBlockStateDefinition } from '../../Divider';
import { IconBlockStateDefinition } from '../../Icon';
import { IconButtonBlockStateDefinition } from '../../IconButton';
import { ImageBlockStateDefinition } from '../../Image';
import { ProgressBlockStateDefinition } from '../../Progress';
import { StackBlockStateDefinition } from '../../Stack';
import { TagBlockStateDefinition } from '../../Tag';
import { TypographyBlockStateDefinition } from '../../Typography';

const walkthroughBlockStateDefinitions: BlockStateDefinition[] = [
  new ButtonBlockStateDefinition(),
  new IconBlockStateDefinition(),
  new IconButtonBlockStateDefinition(),
  new CardBlockStateDefinition(),
  new TypographyBlockStateDefinition(),
  new StackBlockStateDefinition(),
  new TagBlockStateDefinition(),
  new DividerBlockStateDefinition(),
  new ImageBlockStateDefinition(),
  new CarouselBlockStateDefinition(),
  new ProgressBlockStateDefinition(),
];

const blocks = {};

const walkthroughRunnerRegistry = new BlocksRegistry({
  name: 'walkthrough-runner',
  blockStateDefinitions: walkthroughBlockStateDefinitions,
  blockRenderer: RunnerBlockRenderer,
  blocks,
});

export { walkthroughRunnerRegistry };
